import useMaterials from "@/hooks/useMaterials";
import { SearchQueryParameterController } from "@/hooks/useSearchQueryParameter";
import { useRouter } from "next/router";
import { FC, useCallback } from "react";
import { ProductSearchQueryParameter } from "@/types/ProductSearchQueryParameter";
import MultiSelect from "@/components/MultiSelect";
import NavigationSection from "@/components/NavigationSection";

interface Props {
  query: ProductSearchQueryParameter;
  queryController: SearchQueryParameterController<ProductSearchQueryParameter>;
}

const NavigationSectionMaterial: FC<Props> = ({
  query: { material_id },
  queryController,
}): JSX.Element => {
  const router = useRouter();
  const materials = useMaterials();

  const materialSelectChangeHandler = useCallback(
    (selected) => {
      router.push(
        queryController.toPath({
          material_id: selected.value.toString(),
        }),
      );
    },
    [router, queryController],
  );

  return (
    <NavigationSection title={`素材`} defaultOpen={!!material_id}>
      <MultiSelect
        instanceId="material"
        existEntities={materials}
        onChange={materialSelectChangeHandler}
        selectedId={parseInt(material_id, 10)}
      />
    </NavigationSection>
  );
};
export default NavigationSectionMaterial;
